/**
 *  Logic that is used to cast the needed data in a specific model.
 */
import { forOwn, } from './../../utils';
/**
 *  Used for casting a value to a valid date. The method returns the original
 *  value if it could not be casted to a valid date object.
 */
function castDate(value) {
    if (!value || value instanceof Date) {
        return value;
    }
    const parsed = Date.parse(value);
    return !isNaN(parsed) ? new Date(value) : value;
}
/**
 * Returns a date object with the datetime fixed to the value
 *
 * Used for showing dates in the timezone of the event instead of the users
 *
 * See also DD-Frontend-2725
 *
 * @param value
 */
function castDateAsIs(value) {
    if (!value || value instanceof Date) {
        return value;
    }
    const parsed = Date.parse(value);
    if (!isNaN(parsed)) {
        var date = new Date(value);
        let year = parseInt(value.substring(0, 4));
        let month = parseInt(value.substring(5, 7));
        let day = parseInt(value.substring(8, 10));
        let hours = parseInt(value.substring(11, 13));
        let minutes = parseInt(value.substring(14, 16));
        let seconds = parseInt(value.substring(17, 19));
        date.setFullYear(year, month - 1, day);
        date.setHours(hours, minutes, seconds);
        return date;
    }
    return value;
}
export function event(event) {
    event.status_until = castDate(event.status_until);
    event.start = castDateAsIs(event.start);
    event.end = castDateAsIs(event.end);
}
export function eventDate(eventDate) {
    eventDate.start = castDateAsIs(eventDate.start);
    eventDate.end = castDateAsIs(eventDate.end);
}
export function ticket(ticket) {
    ticket.available_from = castDate(ticket.available_from);
    ticket.available_until = castDate(ticket.available_until);
}
/**
 *  Used for casting a collection of models.
 */
function castMultiple(models, method) {
    forOwn(models, method);
}
export function events(events) {
    castMultiple(events, event);
}
export function eventDates(eventDates) {
    castMultiple(eventDates, eventDate);
}
export function tickets(tickets) {
    castMultiple(tickets, ticket);
}
//# sourceMappingURL=cast.js.map